// Document type labels in German
export const DOCUMENT_TYPE_LABELS = {
    BIRTH_CERTIFICATE: 'Geburtsurkunde',
    DEATH_CERTIFICATE: 'Sterbeurkunde',
    MARRIAGE_CERTIFICATE: 'Heiratsurkunde',
    BAPTISM_RECORD: 'Taufschein',
    CHURCH_BOOK: 'Kirchenbuch',
    CENSUS: 'Volkszählung',
    MILITARY_RECORD: 'Militärdokument',
    PASSPORT: 'Reisepass',
    LETTER: 'Brief',
    NEWSPAPER: 'Zeitung',
    WILL: 'Testament',
    CONTRACT: 'Vertrag',
    OTHER: 'Sonstiges',
};
//# sourceMappingURL=document.js.map